module.exports = __webpack_public_path__ + "static/media/food-insecurity.55cad4c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/food-insecurity.jpg
// module id = 726
// module chunks = 13